<template>
    <div class="weChat-index">
        <div class="header clearfix">
            <div class="left">
                <div class="title">绑定授权公众号后，即可对公众号进行管理维护，挖掘公众号粉丝</div>
            </div>
            <div class="right">
                <el-button class="add" type="warning" @click="openAuth">新增公众号</el-button>
            </div>
        </div>
        <div class="body">
            <el-table :data="tableData" border class="omtable" style="width: 100%">
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="name" label="公众号名称"></el-table-column>
                <el-table-column label="公众号图标">
                    <template slot-scope="scope">
                        <img :src="scope.row.headImg" v-if="scope.row.headImg" class="wechat-logo">
                    </template>
                </el-table-column>
                <el-table-column prop="serviceTypeInfo" label="公众号类型">
                    <template slot-scope="scope">
                        <div v-if="scope.row.serviceTypeInfo==1">订阅号</div>
                        <div v-if="scope.row.serviceTypeInfo==2">服务号</div>
                    </template>
                </el-table-column>
                <el-table-column prop="todayNewFans" width="120px" label="今日新增粉丝">
                    <template slot-scope="scope">
                        {{scope.row.todayNewFans||0}}
                    </template>
                </el-table-column>
                <el-table-column prop="totalFans" width="120px" label="总粉丝">
                    <template slot-scope="scope">
                        {{scope.row.totalFans||0}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="230px">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="goEditPage(scope.row)">自定义菜单</el-button>
                        <el-button type="danger" size="small" @click="delData(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="page"  background layout="total,prev, pager, next" @current-change="pageChange" :page-size='10' :total="listCount">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import commom from "../../api/common";
//当前实例组件
export default {
    data: () => ({
        userinfo:{},
        listCount:0,
        tableData:[],
        pageNum:1,
        authUrl:"",// 微信授权url
        formShow:false
    }),
    components: {},
    mounted() {
        this.userinfo = this.$tools.getLocal("userinfo");
        this.getList();
        if(this.$route.query.error == 1) {
            this.$confirm(
                '授权失败，公众号未通过微信认证，无法绑定', '绑定失败', {
                    confirmButtonText: '确定',
                    type:"error",
                    showCancelButton:false
                })
            .then(()=> {
                this.$router.replace({
                    path:"/weChat/index"
                })
            })
        }
    },
    methods: {
        goEditPage(item){
            this.$router.push({
                path:'/weChat/editMenu',
                query:{
                    id:item.id,
                    name:item.name,
                }
            })
        },
        openAuth(){
            this.$confirm(
                '是否确定将公众号绑定授权给凤栖云服开放平台？绑定授权后，公众号配置的菜单内容将被清空，您需要重新进行配置。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                })
            .then(()=> {
                let base = "https://fqyf-f.wts9999.net"
                if(this.$config.env == 1){
                    base = "http://fans.fxyf99.com"
                }
                const authUrl =  base+"/bplat/component/creatAuthLinkAndOpenPage?mechanId="+this.userinfo.mechanId+"&userId="+this.userinfo.id;
                window.open(authUrl);
            })
        },
        delData(item){
            this.$confirm(
                '确认删除公众号？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            .then(()=> {
                this.$http({
                    url:'/wechatthirdplat/subscription',
                    type:'delete',
                    params: {ids:item.id},
                }).then((data)=> {
                    if(this.tableData.length == 1) {
                        this.pageNum = 1;
                    }
                    this.getList();
                    this.$message.success('删除成功');
                })
            })
        },
        pageChange(page){
            this.pageNum = page;
            this.getList();
        },
        getList(){
            const params = {
                userId:this.userinfo.id,
                pageSize:10,
                pageNum:this.pageNum
            }
            this.$http({
                url:'/wechatthirdplat/subscription/read/list',
                type:'put',
                params: params,
            }).then((data)=> {
                this.tableData = data.data;
                this.listCount = data.total;
            })
        }
    },
};
</script>
<style lang="scss">
@import "./index";
</style>
